import { useRouter } from 'next/router';

import SignUpBullets from '@/components/SignUpBullets';

import * as styles from './index.module.scss';

const HeroSignup = () => {
  const router = useRouter();

  return (
    <div className={styles['hero-category-container']}>
      <div className={`${styles['container']} container`}>
        <h1>Join our Network and Get Quality Leads Today</h1>
        <div className="button large" onClick={() => router.push('/signup/business-info')}>
          Get Started Now
        </div>
        <SignUpBullets />
      </div>
    </div>
  );
};

export default HeroSignup;
